import React, { useState, useRef, useEffect } from 'react';

export default function CodeInput({ length, onSubmit, status, setStatus, children }) {
    const [values, setValues] = useState(Array(length).fill(''));
    const [lastFilledIndex, setLastFilledIndex] = useState(null);
    const inputRefs = useRef(Array(length).fill(null));

    // disabled focus, this is not working on mobile without a click
    // useEffect(() => {
    //     if (inputRefs.current[0]) {
    //         inputRefs.current[0].focus();
    //     }
    // }, []);

    // useEffect(() => {
    //     // Submit automatically if last input field and value is not empty
    //     if (lastFilledIndex === length - 1) {
    //         handleSubmit();
    //     }
    // }, [lastFilledIndex]);

    // check submit if values (the code) is changed.
    useEffect(() => {
        handleSubmit();
    }, [values]);

    const handleChange = (e, index) => {
        const { value } = e.target;

        console.log("change index " + index + " of " + (length-1) + ":", value);

        setValues((prevValues) => {
            const newValues = [...prevValues];
            newValues[index] = value;

            return newValues;
        });



        if (value.length > 0) {
            if ( index < length - 1) {
                inputRefs.current[index + 1].focus();
            }
            // mark this field as filled
            setLastFilledIndex(index);
        } else if (value.length === 0 && index > 0) {
            inputRefs.current[index - 1].focus();
            setLastFilledIndex(index - 1);
        }
    };
    const handleKeyDown = (e, index) => {

        const inputElement = inputRefs.current[index];

        let currentValue = inputElement.value;

        let replaceText = false;
        if (inputElement.selectionStart !== inputElement.selectionEnd && inputElement.selectionEnd > 0) {
            replaceText = true;
        }

        if (replaceText === false) {

            // allowed characters
            console.log(e);
            if (!e.key.match(/[0-9,]/) && !e.ctrlKey && e.key.length === 1) {
                console.log("statement 0");
                e.preventDefault();
            }

            if (e.key === 'Backspace' && values[index].length === 0 && index > 0) {
                console.log("statement 1");
                inputRefs.current[index - 1].focus();
                setLastFilledIndex(index - 1);
            } else if (e.key === 'ArrowLeft' && index > 0) {
                console.log("statement 2");
                inputRefs.current[index - 1].focus();
                inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length); // set cursor at the end
            } else if (e.key === 'ArrowRight' && index < length - 1) {
                console.log("statement 3");
                inputRefs.current[index + 1].focus();
                inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length); // set cursor at the end
            } else if (e.key !== 'Backspace' && !e.ctrlKey && currentValue.length >= 1 && index < length-1) {
                console.log("statement 4");
                // when typing a second character, focus already on the next inputfield
                inputRefs.current[index + 1].focus();
            } else if (currentValue.length >= 1) {
                console.log("statement 5");
                // stop adding new character at the last inputfield when already filled/
                if (e.key.match(/[a-zA-Z0-9]/) && !e.ctrlKey && e.key.length === 1) {
                    console.log("statement 5.1");
                    e.preventDefault();
                }
            }

        }
    };

    const handleSubmit = () => {
        const code = values.join('');
        if (code.length === length) {
            onSubmit(code);
        } else {
            console.log("reset status");
            status = null;
            setStatus(status);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            {values.map((value, index) => (
                <input
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    inputMode="numeric" // Specify input mode as 'numeric'
                    value={value}
                    onChange={(e) => handleChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    className={`shadow-sm appearance-none border rounded-xl text-center w-10 py-2 px-3 text-gray-700 m-1 h-12 leading-tight focus:outline-none ${(status === 'unauthorized') ? 'border-red-600 focus:border-red-700' : 'border-grey-400 focus:border-gray-400'}`}
                />
            ))}
            <br/>
            {children}



        </form>
    );
};
